import * as BookingStepsActions from '../actions/booking-steps.actions';
import * as BookingStepsState from '../states/booking-steps.state';
import { BookingStep } from '@ibe/models/ui';

export class State extends BookingStepsState.State { }

const initialState: BookingStepsState.State = BookingStepsState.initialState;
/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {BookingStepsActions.Actions} action
 * @returns {BookingStepsState.State}
 */
export function reducer(state = initialState, action: BookingStepsActions.Actions): BookingStepsState.State {
	switch (action.type) {
		case BookingStepsActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { loading: true });
			return state;
		case BookingStepsActions.ActionTypes.PUT_BOOKINGSTEPS:
			state = Object.assign({}, state, { loading: false, orig_booking_steps: action.payload.booking_steps, ...action.payload });
			return state;
		case BookingStepsActions.ActionTypes.PUT_STEPS:
			state = Object.assign({}, state, { loading: false, booking_steps: action.payload });
			return state;
		case BookingStepsActions.ActionTypes.PUT_CURRENTSTEP:
			state = Object.assign({}, state, { loading: false, current_step: action.payload });
			return state;
		case BookingStepsActions.ActionTypes.PUT_CURRENTPAGE:
			state = Object.assign({}, state, { loading: false, current_page: action.payload });
			return state;
		case BookingStepsActions.ActionTypes.PUT_BOOKINGTYPE:
			state = Object.assign({}, state, { loading: false, booking_type: action.payload });
			return state;
		case BookingStepsActions.ActionTypes.PUT_ALL_COSTS_PER_DAY:
			state = Object.assign({}, state, { costsPerDay: action.payload });
			return state;
		case BookingStepsActions.ActionTypes.PUT_TTT:
			state = Object.assign({}, state, { loading: false, timeToThink: action.payload });
			return state;
		case BookingStepsActions.ActionTypes.RESET_SELECTED_FLIGHT:
			const steps = [...state.booking_steps];
			const newSteps: Array<BookingStep> = [];
			steps.forEach(step => newSteps.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })));
			state = Object.assign({}, state, { loading: false, booking_steps: newSteps, current_step: 0 });
			return state;
		case BookingStepsActions.ActionTypes.RESELECT_LAST_FLIGHT:
			const oldSteps = [...state.booking_steps];
			const stepToChange = oldSteps[oldSteps.length - 1];
			oldSteps[oldSteps.length - 1] = Object.assign(new BookingStep(null, null), stepToChange, { flight_selected: false });
			state = Object.assign({}, state, { loading: false, booking_steps: oldSteps });
			return state;
		case BookingStepsActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: BookingStepsState.State) => state.loading;
export const getOrigBookingSteps = (state: BookingStepsState.State) => state.orig_booking_steps;
export const getBookingSteps = (state: BookingStepsState.State) => state.booking_steps;
export const getBookingCurrentStep = (state: BookingStepsState.State) => state.current_step;
export const getBookingCurrentPage = (state: BookingStepsState.State) => state.current_page;
export const getBookingType = (state: BookingStepsState.State) => state.booking_type;
export const getCostsPerDay = (state: BookingStepsState.State) => state.costsPerDay;
export const getTimeToThink = (state: BookingStepsState.State) => state.timeToThink;
